module.exports = __webpack_public_path__ + "static/media/retails.bd6498ed.svg";